
// Basic
import { useState } from 'react';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import MerchantAccountsTable from '@/app/modules/accounts/components/tables/MerchantAccountsTable';
import ModalCreateMerchantAccount from '@/app/modules/accounts/components/modals/createMerchantAccount/ModalCreateMerchantAccount';
// Common
import RouteUrls from '../enums/RouteUrls';
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsAccount } from '@/app/i18n/namespaces';
import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';

/**
 *
 * @returns {JSX} MerchantAccounts
 */
function MerchantAccounts() {

    // Store
    const permissions = useSessionStore(s => s.session.permissions);
    // State
    const [showModalCreateMerchantAccount, setShowModalCreateMerchantAccount] = useState(false);

    return (
        <Page>
            <Page.Header
                route={RouteUrls.MERCHANT_ACCOUNTS}
                routeBase={RouteUrls.MERCHANT_ACCOUNTS}
            />
            <Page.Body dataCy='page-accounts'>

                <MerchantAccountsTable
                    filtersEventName={setFiltersEventName('merchant_accounts')}
                    pageActions={
                        <PageActions actions={[{
                            icon: ICONS.ADD_CONTRACT_ACCESS,
                            entity: 'actions.page.add_contract_access',
                            namespace: nsAccount,
                            onClick: () => setShowModalCreateMerchantAccount(true),
                            visible: true,
                            disabled: !hasRequiredPermissions({
                                permissions: permissions,
                                requiredPermissions: [
                                    Permissions.CONTRACTS_ACCESS_CREATE.name
                                ]
                            }),
                            tooltipForbidden: 'title.permissions.access_denied'
                        }]}
                            retractable
                        />
                    } />

            </Page.Body>
            {
                showModalCreateMerchantAccount &&
                <ModalCreateMerchantAccount
                    isOpen={showModalCreateMerchantAccount}
                    setIsOpen={setShowModalCreateMerchantAccount}
                />
            }
        </Page >
    );
}

export default MerchantAccounts;